import React, { FC } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import ShieldIcon from "@mui/icons-material/Security";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import GroupsIcon from "@mui/icons-material/Groups";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import FemaleIcon from "@mui/icons-material/Female";
import SchoolIcon from "@mui/icons-material/School";

interface OpportunityCardsProps {
  selected: boolean;
}

const OpportunityCards: FC<OpportunityCardsProps> = ({ selected }) => {
  const opportunities = [
    {
      icon: <ShieldIcon fontSize="large" />,
      title: selected ? "INR 5 Lacs" : "₹5 लाख",
      subtitle: selected ? "Accidental Insurance" : "दुर्घटना बीमा",
    },
    {
      icon: <CardGiftcardIcon fontSize="large" />,
      title: selected ? "Gifts" : "उपहार",
      subtitle: selected ? "For Dedicated Work" : "समर्पित कार्य के लिए",
    },
    {
      icon: <GroupsIcon fontSize="large" />,
      title: selected ? "1000+" : "1000+",
      subtitle: selected ? "Working Partners" : "कार्यरत पार्ट्नर",
    },
    {
      icon: <CurrencyRupeeIcon fontSize="large" />,
      title: selected ? "Unlimited" : "असीमित",
      subtitle: selected ? "Earnings" : "कमाई",
    },
    {
      icon: <FemaleIcon fontSize="large" />,
      title: selected ? "Women" : "महिला",
      subtitle: selected ? "Empowerment" : "सशक्तिकरण",
    },
    {
      icon: <SchoolIcon fontSize="large" />,
      title: selected ? "Certified" : "प्रमाणित",
      subtitle: selected ? "Training Program" : "प्रशिक्षण कार्यक्रम",
    },
  ];

  return (
    <Box sx={{ py: { xs: 2, sm: 4 }, width: "100%" }}>
      <Typography
        variant="h5"
        component="h2"
        fontWeight={700}
        gutterBottom
        className="join-professional-steps"
        sx={{
          fontSize: { xs: "1.25rem", sm: "1.65rem" },
          textAlign: "left",
          color: "#123524",
        }}
      >
        {selected
          ? "A world of opportunities awaits you!"
          : "अवसरों की दुनिया आपका इंतजार कर रही है!"}
      </Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {opportunities.map((item, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              sx={{
                textAlign: "center",
                py: 2,
                px: 1,
                boxShadow: "0 8px 28px rgba(18, 53, 36, 0.1)",
                borderRadius: "14px",
                width: "100%",
                maxWidth: "220px",
                border: "1px solid rgba(18, 53, 36, 0.1)",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 14px 36px rgba(18, 53, 36, 0.14)",
                },
              }}
            >
              <CardContent sx={{ py: 1.5 }}>
                <Box sx={{ color: "#1f7a4d" }}>{item.icon}</Box>
                <Typography
                  variant="subtitle1"
                  fontWeight={700}
                  sx={{ color: "#123524", mt: 1 }}
                >
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "#5e6d63", mt: 0.5 }}>
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default OpportunityCards;
